import React from 'react'

import {Buttons, ButtonPrimary} from '../../ui-kit/Button'
import Animate from '../../ui-kit/Animate'

import {ButtonBlock, TextBlock, TextCenter, Heading, Paragraph, Content} from '../../styles'

var Text6 = ({onNext}) => {

  return (
    <Content>
      <TextBlock>
        <Animate duration=".8s" delay=".3s">
          <TextCenter>
            <Heading>Nosso foco é</Heading>
            
            <Animate duration=".8s" delay="1.5s">
              <img src="https://i.imgur.com/sKsSRA7.gif" width="110" />
              <br/><br/>
            </Animate>
            
            <Animate duration=".8s" delay="2s">
              <Paragraph>
                <b>De uma vez por todas</b> resolver o problema. Se você não gostar do serviço, seu dinheiro de volta.
              </Paragraph>
            </Animate>
          </TextCenter>
        </Animate>
      </TextBlock>

      <Animate duration=".3s" delay="3s">
        <ButtonBlock>
          <Buttons>
            <ButtonPrimary onClick={onNext}>
              Vamos começar?
            </ButtonPrimary>
          </Buttons>
        </ButtonBlock>
      </Animate>
    </Content>
  )

}

export default Text6